import * as Icons from '@ant-design/icons';
import AssignmentAttemptLogModal from 'components/modal/evaluations/assignment/AssignmentAttemptLogModal';
import {
  Alert,
  Button,
  Card,
  Divider,
  Flex,
  Space,
  Tag,
  Typography
} from 'antd';
import { AssignmentEditScoreModal } from 'components/modal/evaluations/assignment/AssignmentEditScoreModal';
import { FileDoneOutlined } from '@ant-design/icons';
import {
  IAssignmentAttempt,
  IAssignmentAttemptCriterionFile,
  IAssignmentAttemptCriterionFileItem
} from 'interfaces/assignments';
import { PageHeader } from 'components/professor_area/PageHeader';
import { ShowFieldData } from 'components/ShowFieldData';
import { ShowLayout } from 'components/layout/layout/ShowLayout';
import { TagField } from '@refinedev/antd';
import { tagColorByStatus } from '../../../utils/statusColorMapping';
import { translateAssignmentAttemptStatus } from '../../../services/assignments';
import { useModal, useShow } from '@refinedev/core';

const { Title } = Typography;

export const AssignmentAttemptShow = () => {
  const { queryResult } = useShow<IAssignmentAttempt>();
  const logModal = useModal();
  const editScoreModal = useModal();

  const attempt = queryResult?.data?.data;

  const onViewLogModal = () => {
    logModal.show();
  };

  const onEditScoreModal = () => {
    editScoreModal.show();
  };

  return (
    <ShowLayout>
      <PageHeader
        title={attempt?.assignment_name}
        icon={FileDoneOutlined}
        meta={
          <Flex>
            <Tag color={tagColorByStatus(attempt?.status || '')}>
              {translateAssignmentAttemptStatus(attempt?.status ?? '')}
            </Tag>
          </Flex>
        }
        actions={
          <Space>
            <Button
              icon={<Icons.EyeOutlined />}
              onClick={onEditScoreModal}
              disabled={
                !!attempt?.status &&
                !['passed', 'failed'].includes(attempt?.status)
              }
            >
              Editar nota
            </Button>

            <Button icon={<Icons.EyeOutlined />} onClick={onViewLogModal}>
              Visualizar alterações
            </Button>
          </Space>
        }
      />

      <Card>
        <Space direction="vertical" size="middle">
          {attempt?.evaluator?.name && (
            <ShowFieldData label="Avaliador" value={attempt?.evaluator?.name} />
          )}

          <ShowFieldData label="Tarefa" value={attempt?.assignment_name} />

          <ShowFieldData
            label="Curso/Disciplina"
            value={attempt?.course_name}
          />

          <ShowFieldData label="Nota" value={attempt?.score ?? '--'} />

          <ShowFieldData label="Feedback" value={attempt?.feedback ?? '--'} />
        </Space>

        <Divider />

        <Title level={5}>Arquivos: </Title>
        <Space direction="vertical" className="w-full">
          {attempt?.criteria_files.map(
            (criteria_file: IAssignmentAttemptCriterionFile) => (
              <Space
                direction="vertical"
                key={criteria_file.id}
                className="w-full"
              >
                <Typography.Text className="font-medium">
                  Critério: {criteria_file.name}
                </Typography.Text>

                {!criteria_file?.items?.length && (
                  <Alert
                    type="warning"
                    showIcon
                    className="p-4"
                    message={
                      criteria_file.answer_type === 'file' ? (
                        <>
                          O aluno não enviou o arquivo <b>dentro do prazo</b>{' '}
                          estipulado para esta atividade
                        </>
                      ) : (
                        <>
                          O aluno não enviou escreveu sua resposta{' '}
                          <b>dentro do prazo</b> estipulado para esta atividade
                        </>
                      )
                    }
                  />
                )}

                {criteria_file.items.map(
                  (item: IAssignmentAttemptCriterionFileItem) => (
                    <>
                      <Button href={item.url} target="_blank" key={item.id}>
                        <Icons.DownloadOutlined />
                        {item.name}
                      </Button>
                    </>
                  )
                )}
              </Space>
            )
          )}
        </Space>

        {attempt?.id && logModal.visible && (
          <AssignmentAttemptLogModal attemptId={attempt.id} modal={logModal} />
        )}

        {attempt?.id && editScoreModal.visible && (
          <AssignmentEditScoreModal attempt={attempt} modal={editScoreModal} />
        )}
      </Card>
    </ShowLayout>
  );
};
